// `lg` here is CmsImage's own breakpoint scale (>= 1440px), not Tailwind's.
// Since CMS-1773 the article content column is 990px at 1440 and 1086px from
// 1536 up (the `max-w-[1536px]` cap minus the 40px margins, the 346px MPC
// sidebar and the 24px gap), so 1086px is its upper bound.
export const ARTICLE_IMAGE_SIZES = {
  _: '100vw',
  lg: '1086px',
} as const;
